// ══════════════════════════════════════════════════════════════════
// PGLC THEME JS — alles in einer Datei, keine Abhängigkeiten
// ══════════════════════════════════════════════════════════════════

// ── CART STATE ────────────────────────────────────────────────────
var CART = {
  busy: false,

  formatMoney: function(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  },

  // Cart von Shopify laden
  fetch: function(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { callback(cart); })
      .catch(function(e) { console.error('Cart fetch:', e); });
  },

  // Produkt hinzufügen
  add: function(id, quantity) {
    if (CART.busy) return;
    CART.busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      CART.busy = false;
      CART.render(cart);
      CART.open();
    })
    .catch(function(e) {
      CART.busy = false;
      console.error('Cart add:', e);
    });
  },

  // Menge ändern
  change: function(key, quantity) {
    if (CART.busy) return;
    CART.busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      CART.busy = false;
      CART.render(cart);
    })
    .catch(function(e) {
      CART.busy = false;
      console.error('Cart change:', e);
    });
  },

  // Drawer öffnen
  open: function() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  // Drawer schließen
  close: function() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  },

  // Drawer HTML rendern
  render: function(cart) {
    var content = document.getElementById('cartContent');
    var footer = document.getElementById('cartFooter');
    var countEl = document.getElementById('cartCount');
    var totalEl = document.getElementById('cartTotal');

    if (countEl) countEl.textContent = cart.item_count;

    if (!content) return;

    if (cart.item_count === 0) {
      content.innerHTML = [
        '<div class="cart-drawer__empty">',
        '<svg viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke="currentColor">',
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>',
        '<line x1="3" y1="6" x2="21" y2="6"/>',
        '<path d="M16 10a4 4 0 0 1-8 0"/>',
        '</svg>',
        '<p>Dein Warenkorb ist leer</p>',
        '<a href="/collections/all" class="btn btn--black" onclick="CART.close()">Weiter einkaufen</a>',
        '</div>'
      ].join('');
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) {
      footer.style.display = 'block';
      if (totalEl) totalEl.textContent = CART.formatMoney(cart.total_price);
    }

    var html = '';
    cart.items.forEach(function(item) {
      var img = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.[a-z]+(\?.*)?$)/, '_80x106_crop_center$1')
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p style="font-size:12px;color:var(--gray-text);margin-bottom:8px;">' + item.variant_title + '</p>'
        : '';

      html += '<div class="cart-line" data-key="' + item.key + '" style="display:flex;gap:16px;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid var(--gray-mid);">';
      if (img) {
        html += '<a href="' + item.url + '" onclick="CART.close()">';
        html += '<img src="' + img + '" alt="' + item.title + '" style="width:80px;height:106px;object-fit:cover;display:block;flex-shrink:0;">';
        html += '</a>';
      }
      html += '<div style="flex:1;min-width:0;">';
      html += '<a href="' + item.url + '" onclick="CART.close()" style="font-size:14px;font-weight:500;color:var(--black);display:block;margin-bottom:4px;">' + item.product_title + '</a>';
      html += variant;
      html += '<p style="font-size:14px;font-weight:600;margin-bottom:12px;">' + CART.formatMoney(item.final_line_price) + '</p>';
      html += '<div style="display:inline-flex;align-items:center;border:1px solid var(--gray-mid);border-radius:2px;">';
      html += '<button data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" data-action="change" style="background:none;border:none;width:28px;height:28px;font-size:16px;cursor:pointer;color:var(--gray-text);">&#8722;</button>';
      html += '<span style="width:28px;text-align:center;font-size:13px;font-weight:500;border-left:1px solid var(--gray-mid);border-right:1px solid var(--gray-mid);height:28px;display:flex;align-items:center;justify-content:center;">' + item.quantity + '</span>';
      html += '<button data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" data-action="change" style="background:none;border:none;width:28px;height:28px;font-size:16px;cursor:pointer;color:var(--gray-text);">&#43;</button>';
      html += '</div></div>';
      html += '<button data-key="' + item.key + '" data-qty="0" data-action="change" style="background:none;border:none;cursor:pointer;color:var(--gray-mid);font-size:14px;align-self:flex-start;padding:0;">&#10005;</button>';
      html += '</div>';
    });
    content.innerHTML = html;
  }
};

// ── GLOBALE SHORTCUTS (für onclick im HTML) ───────────────────────
function openCart() { CART.open(); }
function closeCart() { CART.close(); }
function addToCart(id, qty) { CART.add(id, qty); }

// ── EVENT DELEGATION für Cart Buttons ────────────────────────────
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="change"]');
  if (!btn) return;
  var key = btn.dataset.key;
  var qty = parseInt(btn.dataset.qty, 10);
  if (key !== undefined && !isNaN(qty)) {
    CART.change(key, qty);
  }
});

// ── FAQ ───────────────────────────────────────────────────────────
function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(el) { el.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}

// ── PRODUCT ACCORDION ─────────────────────────────────────────────
function toggleAccordion(btn) {
  var item = btn.closest('.accordion-item');
  item.classList.toggle('open');
}

// ── GALLERY THUMBS ────────────────────────────────────────────────
function selectThumb(el, src) {
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  el.classList.add('active');
  var main = document.querySelector('.gallery-main img');
  if (main) main.src = src;
}

// ── SIZE / COLOR ──────────────────────────────────────────────────
function selectSize(btn) {
  if (btn.classList.contains('soldout')) return;
  btn.closest('.size-swatches').querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
}
function selectColor(el) {
  el.closest('.color-swatches').querySelectorAll('.swatch').forEach(function(s) { s.classList.remove('active'); });
  el.classList.add('active');
}

// ── MOBILE MENU ───────────────────────────────────────────────────
function toggleMobileMenu() {
  var menu = document.getElementById('mobileMenu');
  var overlay = document.getElementById('mobileOverlay');
  if (!menu) return;
  menu.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open');
  document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
}

// ── ANNOUNCEMENT BANNER ───────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  // Cart initialisieren
  CART.fetch(function(cart) { CART.render(cart); });

  // Banner
  var msgs = [
    'Kostenloser Versand ab 100\u20AC',
    'Neue Kollektion jetzt verf\u00FCgbar'
  ];
  var idx = 0;
  var bannerText = document.querySelector('.banner span');
  var prev = document.querySelector('.banner__arrow:first-child');
  var next = document.querySelector('.banner__arrow:last-child');
  if (prev && next && bannerText) {
    next.addEventListener('click', function() {
      idx = (idx + 1) % msgs.length;
      bannerText.textContent = msgs[idx];
    });
    prev.addEventListener('click', function() {
      idx = (idx - 1 + msgs.length) % msgs.length;
      bannerText.textContent = msgs[idx];
    });
  }
});
